import { TimeSource } from '../types';

export class LiveTimeSource implements TimeSource {
  mode: 'live' | 'sim' = 'live';

  getCurrentTime(): Date {
    return new Date();
  }
}

export class SimulatedTimeSource implements TimeSource {
  mode: 'live' | 'sim' = 'sim';
  private offsetMinutes: number = 0;
  private baseDate: Date;

  constructor() {
    this.baseDate = new Date();
    this.baseDate.setHours(0, 0, 0, 0);
  }

  setOffset(minutes: number) {
    this.offsetMinutes = minutes;
  }

  setBaseDate(date: Date) {
    const newBase = new Date(date);
    newBase.setHours(0, 0, 0, 0);
    this.baseDate = newBase;
  }

  getCurrentTime(): Date {
    // Return baseDate with specific hours/minutes set
    // This ensures that "12:00" on the slider means "12:00" local time,
    // avoiding issues with DST where 12 hours of duration != 12 hours of clock time.
    const result = new Date(this.baseDate);
    const hours = Math.floor(this.offsetMinutes / 60);
    const mins = this.offsetMinutes % 60;
    
    // Handle seconds/ms to 0 for stability
    result.setHours(hours, mins, 0, 0);
    
    return result;
  }
}

export function createTimeSource(mode: 'live' | 'sim'): TimeSource {
  return mode === 'live' ? new LiveTimeSource() : new SimulatedTimeSource();
}

export function formatCountdown(ms: number): string {
  const minutes = Math.ceil(ms / 60000);
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
}

export function formatShortCountdown(ms: number): string {
  const minutes = Math.ceil(ms / 60000);
  return `${minutes}m`;
}
